import { Link } from 'react-router-dom';

interface ServiceAreaSectionProps {
  title?: string;
  subtitle?: string;
  heading?: string;
  showMap?: boolean;
}

const CITIES = [
  { name: 'Metairie', service: 'Commercial Cleaning', href: '/locations/metairie-la' },
  { name: 'New Orleans', service: 'Janitorial Services', href: '/locations/metairie-la' },
  { name: 'Kenner', service: 'Office Cleaning', href: '/locations/metairie-la' },
  { name: 'Harahan', service: 'Floor Care', href: '/locations/metairie-la' },
  { name: 'Jefferson', service: 'Facility Services', href: '/locations/metairie-la' },
  { name: 'Elmwood', service: 'Janitorial Services', href: '/locations/metairie-la' },
  { name: 'Gretna', service: 'Commercial Cleaning', href: '/locations/metairie-la' },
  { name: 'Westwego', service: 'Office Cleaning', href: '/locations/metairie-la' },
];

export default function SharedServiceAreaSection({
  title = 'Serving Businesses Across Greater New Orleans',
  subtitle = 'Based in Metairie, LA — we deliver reliable commercial cleaning throughout Jefferson Parish, Orleans Parish, and surrounding areas.',
  showMap = true,
}: ServiceAreaSectionProps) {
  return (
    <section className="py-24 bg-navy">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-accent/10 border border-accent/20 rounded-full px-4 py-1.5 mb-5">
            <i className="ri-map-pin-line text-accent text-sm"></i>
            <span className="text-accent text-xs font-body font-semibold uppercase tracking-wider">Service Areas</span>
          </div>
          <h2 className="font-heading font-extrabold text-white text-4xl xl:text-5xl mb-4">{title}</h2>
          <p className="text-white/55 font-body text-lg max-w-2xl mx-auto">{subtitle}</p>
        </div>

        <div className="grid lg:grid-cols-5 gap-8 items-start">
          {/* City Grid */}
          <div className="lg:col-span-2">
            <div className="grid grid-cols-2 gap-3 mb-8">
              {CITIES.map((city) => (
                <Link
                  key={city.name}
                  to={city.href}
                  className="bg-white/5 hover:bg-accent/10 border border-white/10 hover:border-accent/40 rounded-xl p-4 transition-all duration-200 cursor-pointer group"
                >
                  <div className="flex items-center gap-2 mb-1">
                    <i className="ri-map-pin-2-fill text-accent text-sm group-hover:scale-110 transition-transform"></i>
                    <span className="text-white font-heading font-bold text-sm">{city.name}</span>
                  </div>
                  <span className="text-white/40 font-body text-xs">{city.service}</span>
                </Link>
              ))}
            </div>
            <div className="bg-accent/10 border border-accent/20 rounded-2xl p-5">
              <div className="flex items-start gap-3">
                <i className="ri-building-2-line text-accent text-xl mt-0.5 shrink-0"></i>
                <div>
                  <p className="text-white font-heading font-bold text-sm mb-1">OJS Janitorial — Metairie Office</p>
                  <p className="text-white/50 font-body text-xs leading-relaxed">7809 Airline Drive, Suite #307 F<br />Metairie, LA 70003</p>
                  <a href="tel:+15048183347" className="inline-flex items-center gap-1.5 text-accent text-sm font-body mt-3 hover:text-white transition-colors">
                    <i className="ri-phone-line"></i> (504) 818-3347
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          {showMap && (
            <div className="lg:col-span-3 rounded-2xl overflow-hidden border border-white/10 h-[440px]">
              <iframe
                title="OJS Janitorial Service Areas — Greater New Orleans"
                src="https://maps.google.com/maps?q=7809%20Airline%20Drive%20Suite%20307F%20Metairie%20LA%2070003&output=embed&z=12"
                className="w-full h-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
